export default __webpack_public_path__ + "static/media/6.e1206960.png";